module.exports = "/build/web/svg/sponsor/espn.9618a104d536823b25db72c834c53824.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/espn.svg
// module id = 210
// module chunks = 24